import {
  REQUEST_CHAT,
  CONCAT_PRIVATE_CHAT,
  CONCAT_TEAM_CHAT,
  CONCAT_PUBLIC_CHAT,
  RENDER_PRIVATE_CHAT,
  RENDER_PUBLIC_CHAT,
  RENDER_TEAM_CHAT,
  RECEIVE_PRIVATE_CHAT,
  RECEIVE_PUBLIC_CHAT,
  RECEIVE_TEAM_CHAT,
  CHANGE_STATUS_CHAT,
  CLOSE_CHAT,
  REQUEST_CHATS,
  PUBLIC_CHAT_ID,
  PRIVATE_CHAT_ID,
  CHANGE_CHAT_COMMENTS,
  SET_UNREAD_COMMENTS,
  SET_UNREAD_MSGS,
  RECEIVE_CHATS
} from '../actions'


export const showGlobalMessage = (state = false, action) => {
  switch (action.type) {
    case 'SHOW_GLOBAL_MESSAGE':
      return action.showGlobalMessage
    default:
      return state
  }
}

export const updateChats = (state = false, action) => {
  switch (action.type) {
    case 'UPDATE_CHATS':
      return action.updateChats
    default:
      return state
  }
}
const chatState = {
  isOpen: false,
  isFetching: false,
  isFetchingChat: 0,
  publicChats: {
    unreadCount:0
  },
  privateChats: {
    unreadCount:0
  },
  teamChats: {
    unreadCount:0
  },
  renderPublicChat: [],
  renderTeamChat: [],
  renderPrivateChat: []
}

export const chat = (state = chatState, action) => {
  switch (action.type) {
    case REQUEST_CHAT:
      return {
        ...state,
        isFetching: true,
        isFetchingChat: state.isFetchingChat + 1
      }
    case CONCAT_PRIVATE_CHAT:
      return {
        ...state,
        isFetching: true,
        renderPrivateChat: action.payload
      }
    case CONCAT_TEAM_CHAT:
      return {
        ...state,
        isFetching: true,
        renderTeamChat: action.payload
      }
    case CONCAT_PUBLIC_CHAT:

      return {
        ...state,
        isFetching: true,
        renderPublicChat: action.payload
      }
    case RENDER_PRIVATE_CHAT:

      return {
        ...state,
        // isFetchingChat: 0,
        renderPrivateChat: action.payload
      }
    case 'CLEAR_RENDER_CHAT':

      return {
        ...state,
        renderPrivateChat: [],
        renderPublicChat: [],
        publicChats: {
          ...state.publicChats,
          comments:[]
        },
        privateChats:{
          ...state.privateChats,
          comments:[]
        },
        teamChats:{
          ...state.teamChats,
          comments:[]
        },
      }
    case RENDER_PUBLIC_CHAT:

      return {
        ...state,
        renderPublicChat: action.payload
      }
    case RENDER_TEAM_CHAT:

      return {
        ...state,
        renderTeamChat: action.payload
      }

    case RECEIVE_PUBLIC_CHAT:
      return {
        ...state,
        isFetching: false,
        isFetchingChat: state.isFetchingChat - 1,
        publicChats: action.payload
      }

    case CHANGE_CHAT_COMMENTS:
      return {
        ...state,
        [action.chat]:{
          ...state[action.chat],
          comments: action.data
        }
      }

    case SET_UNREAD_COMMENTS:
      return{
        ...state,
        [action.chat]:{
          ...state[action.chat],
          unreadCount: action.data

        }
      }

    case RECEIVE_PRIVATE_CHAT:

      return {
        ...state,
        isFetching: false,
        isFetchingChat: state.isFetchingChat - 1,
        privateChats: action.payload
      }
    case RECEIVE_TEAM_CHAT:
      console.log('RECEIVE_TEAM_CHAT:')
      console.log(action)
      return {
        ...state,
        isFetching: false,
        isFetchingChat: state.isFetchingChat - 1,
        teamChats: action.payload
      }

    case CLOSE_CHAT:
      return {
        ...state,
        isFetchingChat: state.isFetchingChat - 1,
        isFetching: false
      }
    default:
      return state
  }
}
const stateChats = {
  isFetching: false,
  chats: [],
  pageCount:1,
  adminChatOpen:false,
  chatType:PRIVATE_CHAT_ID,
  groupId:0,
  chatTypeId:0,
  typeId:0,
  unReadMsgs:0
}

export const chats = (state = stateChats, action) => {
  switch (action.type) {
    case SET_UNREAD_MSGS:
      return {
        ...state,
        unReadMsgs:action.unReadMsgs
      }
    case 'CHANGE_TYPE':
      return {
        ...state,
        chatType:action.chatType
      }
    case 'SET_GROUP_ID':

      return {
        ...state,
        groupId: action.groupId
      }
    case 'SET_TYPE_ID':

      return {
        ...state,
        typeId: action.typeId
      }
    case 'SET_CHAT_TYPE_ID':

      return {
        ...state,
        chatTypeId: action.chatTypeId
      }
    case 'ADMIN_CHAT_CLOSE':
      return {
        ...state,
        adminChatOpen: false
      }
    case 'ADMIN_CHAT_OPEN':

      return {
        ...state,
        adminChatOpen: true
      }
    case 'ADMIN_CHAT_CLOSE':
      return {
        ...state,
        adminChatOpen: false
      }
    case REQUEST_CHATS:
      return {
        ...state,
        isFetching: true
      }
    case RECEIVE_CHATS:
      return {
        ...state,
        chats: [...action.payload],
        pageCount: action.pageCount,
        isFetching: false
      }
    case CHANGE_STATUS_CHAT:
      let list = state.chats.map(item => {
        if (item.id === action.payload) {
          item.isAnswered = true
        }
        return item
      })

      return {
        ...state,
        chats: list
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/reducers/chats.js